import Checkbox from 'components/Buttons/CheckboxButton';
import Table, { TableColumn } from 'components/Table/Table';
import { INotificationReportSettings } from 'models/response';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'state/actions';
import selectors from 'state/selectors';
import utils from 'utils';
import CronCell from '../components/CronCell';
import cronstrue from 'cronstrue';

const TableReports = () => {
  const t = utils.intl.useTranslator();
  const dispatch = useDispatch();

  const reportList = useSelector(selectors.configurator.getListOfReportSettings);
  const formMode = useSelector(selectors.configurator.getFormModeReports);

  const notificationColumns: TableColumn[] = [
    { accessor: 'folderName', Header: t('folderName'), filterType: 'free' },
    { accessor: 'reportName', Header: t('reportName'), filterType: 'free' },
    { accessor: 'filterName', Header: t('filterName'), filterType: 'free' },
    { accessor: 'mailBody', Header: t('mailBody'), filterType: 'free' },
    {
      accessor: 'cronFrequency',
      Header: t('frequency'),
      Cell: ({ value }: any) => {
        const [tooltip, setTooltip] = useState('');

        return (
          <div
            onMouseEnter={() =>
              setTooltip(cronstrue.toString(value, { verbose: true, locale: navigator.language.split('-')[0] || 'en' }))
            }
            onMouseLeave={() => setTooltip('')}
            title={tooltip}
          >
            <CronCell value={value} />
          </div>
        );
      },
    },
    {
      accessor: 'enabled',
      Header: t('enabled'),
      sortType: 'boolean',
      Cell: ({ value }: any) => {
        return (
          <div style={{ display: 'flex', height: '100%' }}>
            <Checkbox isActive={value} isEditable={false} />
          </div>
        );
      },
    },
  ];

  const onSelection = (rows: INotificationReportSettings[]) => {
    dispatch(actions.configurator.setSelectedReportSettings(rows[0]));
  };

  return (
    <Table
      id="reports-table"
      rowId="idSetting"
      hasToolbar
      columns={notificationColumns}
      rows={reportList}
      hasSelection={!formMode}
      hasPagination
      hasResize
      hasSort
      hasFilter
      onSelection={(rows: INotificationReportSettings[]) => onSelection(rows)}
    />
  );
};
export default TableReports;
